'use strict';

var FirebaseIndirectArray = require('./FirebaseIndirectArray');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeEquipment = require('./KayleeEquipment');
var KayleeUtil = require('./KayleeUtil');
var log = require('../log/Log').channel('KayleeEquipments');

var KayleeEquipments = {
    fromJson: fromJson,
    getEquipments: getEquipments,
};

function fromJson(data) {
    var reqProps = [ '$roomId' ];
    var room = KayleeCache.get('Room: ' + data.$roomId);
    return FirebaseIndirectArray.$fromJson(data, 'Equipments', reqProps, reqProps,
        function(data) { return getEquipments(room); }
    );
}

function getEquipments(room) {
    var key = 'Equipments: ' + room.$id;
    var equipments = KayleeCache.get(key);

    if (equipments === null) {
        equipments = new Equipments(room);
        KayleeCache.put(key, equipments);
    }

    return equipments;
}

function Equipments(room) {
    var srcRef = KayleeBase.app.database()
        .ref('index/equipmentByRoom/' + room.$id);

    this.$room = room;
    this.$nodeType = 'equipments';
    FirebaseIndirectArray.call(this, srcRef, KayleeEquipment.getEquipment);
    KayleeUtil.bindPrototypeMethods(Equipments.prototype, this, this.$items);
    this.$items.$self = this;
    return this.$items;
}

Equipments.prototype = Object.create(FirebaseIndirectArray.prototype);
Equipments.prototype.constructor = Equipments;

Equipments.prototype.$toJson = function() {
    return FirebaseIndirectArray.prototype.$toJson.call(this,
        [], { $roomId: this.$room.$id });
};

Equipments.prototype.toString = function() {
    return '[Equipment for ' + this.$room + ']';
};

Equipments.prototype.$getAvailableDisplaySources = function(eqOrId, altConfig) {
    if (!this.$isLoaded()) return {};

    var eqId;

    if (typeof eqOrId === 'undefined' || eqOrId === null) {
        eqId = '0';
    } else {
        eqId = eqOrId.hasOwnProperty('$id') ? eqOrId.$id : eqOrId;
    }

    var altConfigs = {};

    if (typeof altConfig !== 'undefined' && altConfig !== null) {
        altConfigs[eqId] = JSON.parse(JSON.stringify(altConfig));
    }

    var result = this.$addDisplaySources({}, altConfigs, eqId, false);
    return result;
};

Equipments.prototype.$addDisplaySources = function(srcs, altConfigs, eqId, farContent,
    seenEqIds, parentSrcId) {

    if (typeof seenEqIds !== 'undefined') {
        if (seenEqIds.includes(eqId)) {
            log.debug('already handled eqId = ' + eqId);
            return srcs;
        }

        seenEqIds.push(eqId);
    }

    var config;

    if (altConfigs.hasOwnProperty(eqId)) {
        config = altConfigs[eqId];
    } else if (eqId === '0') {
        config = {};
    } else {
        var eq = this.$recordAt(eqId);

        if (eq === null) {
            log.error('no equipment with id ' + eqId + ' in collection');
            return srcs;
        }

        config = eq.config;
    }

    if (typeof config === 'undefined' ||
        !config.hasOwnProperty('videoInputs')) {
        log.debug('no config for eqId = ' + eqId);
        return srcs;
    }

    for (var srcId in config.videoInputs) {
        if (!config.videoInputs.hasOwnProperty(srcId)) continue;

        var src = config.videoInputs[srcId];
        var tmpParentSrcId = parentSrcId;

        if (typeof tmpParentSrcId === 'undefined') {
            tmpParentSrcId = srcId;
            srcs[tmpParentSrcId] = [];
        }

        var newFarContent = farContent ||
            src.hasOwnProperty('farContent') && src.farContent;

        if (src.hasOwnProperty('source')) {
            var tmpSeenEqIds = seenEqIds;
            if (typeof tmpSeenEqIds === 'undefined') tmpSeenEqIds = [ eqId ];
            this.$addDisplaySources(srcs, altConfigs, src.source.equipmentId,
                newFarContent, tmpSeenEqIds, tmpParentSrcId);
        } else {
            srcs[tmpParentSrcId].push({
                name: src.name,
                icon: src.icon,
                description: src.description,
                farContent: newFarContent,
                equipmentId: eqId,
                videoInputId: srcId
            });
        }
    }

    return srcs;
};

Equipments.prototype.$pruneSourceMenus = function() {
    if (!this.$isLoaded()) return Promise.resolve();

    var promises = [];

    for (var i = 0; i < this.length; i++) {
        var eq = this[i];

        if (!eq.hasOwnProperty('config') ||
            !eq.config.hasOwnProperty('sourceMenu')) continue;

        var sourceMenu = eq.config.sourceMenu;
        var srcs = this.getAvailableDisplaySources(eq);
        var pruneIds = [];

        for (var menuId in sourceMenu) { // check each entry in the sourceMenu
            if (!sourceMenu.hasOwnProperty(menuId)) continue;

            var found = false;

            for (var srcId in srcs) {
                if (!srcs.hasOwnProperty(srcId)) continue;

                var srcsForInput = srcs[srcId];

                for (var j = 0; j < srcsForInput.length; j++) {
                    if (sourceMenu[menuId].equipmentId ===
                        srcsForInput[j].equipmentId &&
                        sourceMenu[menuId].videoInputId ===
                        srcsForInput[j].videoInputId) {
                        found = true;
                        break;
                    }
                }

                if (found) break;
            }

            if (!found) pruneIds.push(menuId);
        }

        for (var k = 0; k < pruneIds.length; k++) {
            delete sourceMenu[pruneIds[k]];
        }

        if (pruneIds.length > 0) {
            promises.push(eq.$save(false));
        }
    }

    return Promise.all(promises);
};

module.exports = KayleeEquipments;
